import ServiceApi from '../../api/serviceApi'
export default {
  state: {
    services: []
  },
  mutations: {
    SERVICE_SET(state, data) {
      state.services = data;
    }
  },
  actions: {
    SERVICE_FETCH(store) {
      ServiceApi.fetch().then(result => {
        store.commit('SERVICE_SET', result);
      }).catch(error => {
        console.error(error);
      })
    }
  }
}
